<template>
  <div style="height: 100%; position: relative" class="mapDiv">
    <map-nav-bar :btmList="btmList" />
    <div id="map" class="map"></div>
    <c-detail
      v-if="JSON.stringify(poisiton) !== '{}'"
      :form="poisiton"
      class="detail"
    ></c-detail>
  </div>
</template>

<script>
//渔业map
import { findOrgCompanyByType } from "@/api/map";
import { get } from "@/api/index";
import * as L from "leaflet";
import "proj4";
import "proj4leaflet";
const esri = require("esri-leaflet");
import "leaflet/dist/leaflet.css";
import { snqyMixin } from "@/util/mixin/snqyMixin";
// import shlData from "../util/geo.json";
export default {
  mixins: [snqyMixin],
  data() {
    return {
      type: "",
      map: null,
      daiArr: [],
      jdArr: [],
      hoverList: [],
      ncIndex: null,
      ncCode: "",
      poisiton: {},
      pointList: [],
      hoverArr: [],
      baseList: [],
      beltObj: {},
      areaList: [],
      pointAnchor: [-10, 50],
      baseAnchor: [13, 36],
      mianArr: [],
      btmList: [
        // {
        //   name: "渔业产园区",
        //   pic: require("images/map/red.jpg")
        // },
        {
          name: "渔业企业",
          pic: require("images/map/yzc.png")
        }
      ]
    };
  },
  mounted() {
    this.$bus.$on("zlchange", val => {
      this.poisiton = {};
      this.curName = val;
      if (val == "产业分布" || val == "养殖基地") {
        this.dataLoad();
      } else if (val === "龙头企业") {
        this.snqyDataload(3);
      } else if (val === "合作社") {
        this.snqyDataload(4);
      } else if (val === "家庭农场") {
        this.snqyDataload(5);
      } else if (val === "农资经营企业") {
        this.snqyDataload(6);
      } else if (val === "生产基地") {
        this.snqyDataload(7);
      }
    });
    this.initMap();
  },
  methods: {
    initMap() {
      // 加载底图
      let tileMapUrl = this.$config.tileMapUrlColor;
      let CRS_4490 = new L.Proj.CRS(
        "EPSG:4490",
        "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs",
        {
          resolutions: this.$config.resolutions,
          origin: [-400.0, 399.9999999999998]
        }
      );

      var map = L.map("map", {
        crs: CRS_4490,
        minZoom: this.$config.sZoom,
        maxZoom: this.$config.mZoom,
        zoomControl: false
      });
      this.map = map; //data上需要挂载
      window.map = map;
      let tileMapLayer = esri.tiledMapLayer({
        url: tileMapUrl
      });
      tileMapLayer.addTo(map);
      //   setTimeout(() => {
      // eslint-disable-next-line no-undef
      // $(".leaflet-control-attribution").empty();
      //   }, 300);
      this.map.setView(
        L.latLng(this.$config.sLat, this.$config.sLng),
        this.nowZoom
      );
      // this.geoloadtest();
      this.dataLoad();
      map.on("click", e => {
        console.log(e.latlng);
        this.poisiton = {};
      });
      map.on("zoom", () => {
        this.nowZoom = this.map.getZoom();
        this.poisiton = {};
      });
      map.on("move", () => {
        this.poisiton = {};
      });
    },
    geoloadtest() {
      this.ditu = L.geoJSON([], {
        style: function() {
          //   console.log("feature", feature);
          return {
            color: "#FF0000",
            fillOpacity: 0.3,
            weight: 2
            //   dashArray: "10"
          };
        },
        onEachFeature: (feature, layer) => {
          if (feature.properties && feature.properties.COUNTRYNAM) {
            layer
              .bindTooltip(
                "<div><ul><li>" +
                  feature.properties.COUNTRYNAM +
                  " " +
                  feature.properties.TOWNNAME +
                  "</li></ul></div>",
                {
                  direction: "top",
                  offset: L.point(0, -10)
                }
              )
              .on({
                mouseover: this.highlight, //鼠标移动上去高亮
                mouseout: this.resetHighlight //鼠标移出恢复原样式
              });
          }
        }
      });
      this.ditu.addTo(this.map);
      /* let DTmap = [];
      for (var i in shlData.features) {
        DTmap[i] = L.geoJSON(shlData.features[i], {
          style: function(feature) {
            console.log("feature", feature);
            return {
              color: "#FF0000",
              fillOpacity: 0.3,
              weight: 2
              //   dashArray: "10"
            };
          }
        })
          .bindTooltip(
            "<div id='table'><ul><li>" +
              shlData.features[i].properties.COUNTRYNAM +
              " " +
              shlData.features[i].properties.TOWNNAME +
              "</li></ul></div>",
            {
              direction: "top"
            }
          )
          .on({
            mouseover: this.highlight, //鼠标移动上去高亮
            mouseout: this.resetHighlight //鼠标移出恢复原样式
          })
          .addTo(this.map);
      } */
    },
    highlight(e) {
      var layer = e.target;
      layer.setStyle({
        weight: 4,
        color: "#FF0000",
        fillOpacity: 0.8
      });
    },

    resetHighlight(e) {
      var layer = e.target;
      layer.setStyle({
        color: "#FF0000",
        weight: 2,
        fillOpacity: 0.3
        // dashArray: "10"
      });
    },
    //加载标记点数据
    dataLoad() {
      if (this.curName === "养殖基地") {
        get("/api/restful/findOrgCompanyYzzAll").then(data => {
          if (this.basesGroup) {
            this.map.removeLayer(this.basesGroup);
            this.baseList = [];
          }
          data.data.forEach(ele => {
            if (!ele.company_name_) {
              return true; //过滤无
            }
            ele.latitude = Number(ele.latitude_);
            ele.longitude = Number(ele.longitude_);
            ele.name = ele.company_name_;
            this.baseList.push(ele);
          });
          this.baseLoad();
        });
      } else if (this.curName === "产业分布") {
        findOrgCompanyByType({ type: 10 }).then(data => {
          console.log("res data ==", data);
          if (this.basesGroup) {
            this.map.removeLayer(this.basesGroup);
            this.baseList = [];
          }
          data.data.map(ele => {
            ele.latitude = Number(ele.latitude);
            this.baseList.push(ele);
          });
          this.baseLoad();
        });
      }
    },

    //基地数据加载
    baseLoad(img = "yzc.png", hasclick = true) {
      this.jdArr = [];
      if (this.basesGroup) {
        this.map.removeLayer(this.basesGroup);
      }
      this.basesGroup = new L.layerGroup();
      let pointUrl = require("images/map/" + img);
      this.baseList.map(it => {
        if (it.latitude) {
          it.lat = it.latitude;
          it.lng = it.longitude;
          //   let pointUrl = require("images/map/" + it.img);
          var myIcons;

          myIcons = L.divIcon({
            html:
              "<div class='indicator-box'><img src='" +
              pointUrl +
              "' /><span class='my-div-names hide'>" +
              it.name +
              "</span ></div>",
            className: "my-div-icon",
            iconAnchor: this.baseAnchor
          });

          let baseLayer = L.marker([it.lat, it.lng], {
            interactive: true,
            icon: myIcons,
            attributes: it
          }).addTo(this.basesGroup);
          this.jdArr.push(baseLayer);
          if (hasclick) {
            baseLayer.on("click", e => {
              if (this.curName === "产业分布") {
                //通用的rightDrawer
                let detailInfo = e.sourceTarget.options.attributes;
                detailInfo.desc = e.sourceTarget.options.attributes.qyjs;
                this.$store.dispatch("drawer/setGraphic", detailInfo);
                this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
              } else if (this.curName === "养殖基地") {
                const data = e.sourceTarget.options.attributes;
                this.poisiton = {};
                let obj = {};
                obj.x = e.containerPoint.x;
                obj.y = e.containerPoint.y;
                let chkArr = [
                  {
                    key: "date_",
                    name: "申请日期"
                  },
                  {
                    key: "apply_type_",
                    name: "申请类型"
                  },
                  {
                    key: "person_name_",
                    name: "个人姓名"
                  },
                  {
                    key: "person_idcard_",
                    name: "身份证号"
                  },
                  {
                    key: "person_phone_",
                    name: "联系电话"
                  },
                  {
                    key: "person_mobilePhone_",
                    name: "手机"
                  },
                  {
                    key: "person_postCode_",
                    name: "邮政编码"
                  },
                  {
                    key: "person_address_",
                    name: "住址"
                  },
                  {
                    key: "company_name_",
                    name: "单位全称"
                  },
                  {
                    key: "company_personName_",
                    name: "法人代表名称"
                  },
                  {
                    key: "company_idcard_",
                    name: "法人身份证号"
                  },
                  {
                    key: "company_mobilePhone_",
                    name: "单位联系电话"
                  },
                  {
                    key: "company_mobilePhone_",
                    name: "单位手机"
                  },
                  {
                    key: "company_postCode_",
                    name: "单位邮政编码"
                  },
                  {
                    key: "company_address_",
                    name: "单位地址"
                  },
                  {
                    key: "properties_",
                    name: "水域滩涂所有制性质"
                  },
                  {
                    key: "sy_type_",
                    name: "水域、滩涂类型"
                  },
                  {
                    key: "yz_type_",
                    name: "水域滩涂养殖方式"
                  },
                  {
                    key: "address_",
                    name: "地区"
                  },
                  {
                    key: "town_",
                    name: "乡(镇)"
                  },
                  {
                    key: "vllge_",
                    name: "村"
                  },
                  {
                    key: "area_",
                    name: "水域、滩涂养殖面积",
                    unit: "公顷"
                  },
                  {
                    key: "begin_date_",
                    name: "核准水域滩涂并殖权期限开始日期"
                  },
                  {
                    key: "end_date_",
                    name: "核住水域滩泠养殖权期限结束日期"
                  },
                  {
                    key: "slg_",
                    name: "受理机构"
                  },
                  {
                    key: "slr_",
                    name: "受理人"
                  },
                  {
                    key: "sh_date_",
                    name: "审核发证日期"
                  }
                ];
                let arr = [];
                obj.name = data.name;
                chkArr.forEach(e => {
                  if (data[e.key]) {
                    arr.push({
                      name: e.name,
                      num: data[e.key],
                      unit: e.unit || ""
                    });
                  }
                });
                obj.dataList = arr;
                this.poisiton = obj;
              }
            });
          }
          baseLayer.on("mouseover", it => {
            // this.ncCode = it.target.options.attributes.code;
            console.log("it", it.target.options.attributes);
            it.sourceTarget
              .getElement()
              .querySelector(".my-div-names")
              .classList.remove("hide");
          });
          baseLayer.on("mouseout", it => {
            it.sourceTarget
              .getElement()
              .querySelector(".my-div-names")
              .classList.add("hide");
          });
        }
      });
      this.map.addLayer(this.basesGroup);
    }
  },
  destroyed() {
    if (this.ditu) {
      this.map.removeLayer(this.ditu);
      this.ditu = null;
    }
    this.$bus.$off("zlchange");
  }
};
</script>

<style lang="stylus" scoped>
.map
    background none !important
    width 100%
    height calc(100% + 105px)
    z-index 9

    // >>>.leaflet-tile-pane
    // display none
    >>>.leaflet-bar
        display none

    >>>.leaflet-bottom
        display none

    .ncDetail
        position absolute

    >>>
        .my-div-icon
            color #fff

        .indicator-box
            position relative

        .my-div-name
            font-size .08rem
            border 1px #fff solid
            border-radius 5px
            background-color rgba(15, 62, 112, .8)
            padding 2px 8px

        .my-div-name:hover
            z-index 999
            font-size .09rem

        .my-div-names.hide
            display none
        .my-div-names
            font-size .07rem
            color #4DB5FE
            position absolute
            top -34px
            left 15px
            width max-content
            padding .01rem .06rem
            border-radius 5px
            border 1px solid #4DB5FE
            background #011C46
            transform translateX(-50%)
            &:before
                content: '';
                transform: translate(-50%,0);
                position: absolute;
                bottom: -10px;
                left: 50%;
                opacity: 1;
                border-top: solid 10px #4DB5FE;
                border-right: solid 10px transparent;
                border-left: solid 10px transparent;
            &:after
                content: '';
                transform: translate(-50%,0);
                position: absolute;
                bottom: -9px;
                left: 50%;
                opacity: 1;
                border-top: solid 10px #011C46;
                border-right: solid 10px transparent;
                border-left: solid 10px transparent;
        .my-div-names.lt
            background #FF9000
            &:before
                border-top-color #FF9000
</style>
